import Vue from "vue";
import VueI18n from "vue-i18n";
import Cookie from "js-cookie";

Vue.use(VueI18n);

// 语言 key
const DEF_LANG = "zh-CN";
const KEY_LANG = "i18nextLng";

const domain = `.${document.domain
  .split(".")
  .reverse()
  .slice(0, 2)
  .reverse()
  .join(".")}`;

// Cookie 写入辅助函数，统一添加 SameSite=None; Secure 以支持跨域 iframe 读写
export const setI18nCookie = (lang = DEF_LANG) => {
  console.log("setI18nCookie", lang, domain);
  let options = {
    expires: 365,
    domain,
  }
  if(window.location.protocol === 'https:'){
    options = {
      ...options,
      secure: true,
      sameSite: 'None'
    }
  }
  Cookie.set(KEY_LANG, lang, options);
};

// 手动修正 cookie 中的语言值，映射到项目支持的语言 key
// 优先级：url > iframe嵌套 > cookie > 浏览器
(function normalizeCookieLang() {
  let normalized = "";
  // url 参数
  if(!normalized){
    const urlLang = new URL(window.location.href).searchParams.get('language') || ''
    if (urlLang.startsWith("zh")) normalized = "zh-CN";
    if (urlLang.startsWith("en")) normalized = "en-US";
  }
  console.log(normalized, 1)

  // 是否iframe嵌套
  if(!normalized){
    if(window.top !== window.self){
      normalized = 'zh-CN'
    }
  }
  console.log(normalized, 2)

  // cookie
  if(!normalized){
    const i18nCookie = Cookie.get(KEY_LANG) || '';
    if (i18nCookie.startsWith("zh")) normalized = "zh-CN";
    if (i18nCookie.startsWith("en")) normalized = "en-US";
  }
  console.log(normalized, 3)

  // cookie 中没有语言值，则从浏览器语言推断
  if (!normalized) {
    const browserLang = navigator.language || navigator.userLanguage;
    if (browserLang && browserLang.startsWith("zh")) normalized = "zh-CN";
    else if (browserLang && browserLang.startsWith("en")) normalized = "en-US";
  }
  console.log(normalized, 4)

  normalized = normalized || DEF_LANG;
  setI18nCookie(normalized);
})();

/**
 * 获取语言优先级：cookie > navigator.language > zh-CN
 */
function getLanguage() {
  const cookieLang = Cookie.get(KEY_LANG);
  return cookieLang || DEF_LANG;
}

/**
 * 自动加载翻译文件
 * 目录结构：locales/zh-CN/common.json -> messages['zh-CN'].common
 */
function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach(key => {
    // key 示例: "./zh-CN/common.json"
    const matched = key.match(/\/([A-Za-z0-9-_]+)\/([A-Za-z0-9-_]+)\.json$/i);
    if (matched && matched.length > 2) {
      const lang = matched[1]; // zh-CN / en-US
      const ns = matched[2]; // common / header / ...
      if (!messages[lang]) messages[lang] = {};
      messages[lang][ns] = locales(key);
    }
  });
  return messages;
}

const i18n = new VueI18n({
  locale: getLanguage(),
  fallbackLocale: "zh-CN",
  silentTranslationWarn: true,
  messages: loadLocaleMessages()
});

window.setI18nCookie = setI18nCookie;

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js